// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Button from 'components/common/Button';
import message from 'antd/lib/message';
// APOLLO
import createQuestion from 'ApolloClient/Mutations/createQuestion';
import myQuestionsQuery from 'ApolloClient/Queries/myQuestions';
import questionsQuery from 'ApolloClient/Queries/questions';
import { graphql } from 'react-apollo';
// COMPONENTS
import FormModal from 'components/common/FormModal';
// import SubmittingSpinner from '/imports/ui/components/forms/SubmittingSpinner';
import QuestionForm from 'components/forms/QuestionForm';
// LIB
import ErrorHelpers from 'lib/helpers/ErrorHelpers';

export class CustomQuestionModal extends React.Component {
  state = {
    visible: false,
    title: '',
    categories: [],
    errors: [],
  };

  getParams = () => {
    return {
      title: this.state.title,
      categories: this.state.categories.map(item => item.key), // categories is an array of _ids
    };
  };

  onClear = () => {
    return this.setState({
      loading: false,
      title: '',
      categories: [],
      visible: false,
    });
  };

  updateAfterMutation = (proxy, { data }) => {
   

    // will update local apollo cache after the mutation. see apollo docs.
    const localData = proxy.readQuery({
      query: myQuestionsQuery,
      variables: {
        params: null
      }
    });

    // filter out the client we just deleted form the local apollo cache
    localData.myQuestions.push(data.createQuestion);
    // overwrite the apollo cache with filtered array

    proxy.writeQuery({
      query: myQuestionsQuery,
      variables: {
        params: null
      },
      data: {
        ...localData 
      },
    });

  };

  onSuccessfullyValidated = async variables => {
    let res;

    try {
      res = await this.props.createQuestion({
        variables,
        update: this.updateAfterMutation,
        refetchQueries: [
          {
            query: myQuestionsQuery,
            variables: { params: {} },
          },
          {
            query: questionsQuery,
            variables: { params: {} },
          },
        ],
      });
    } catch (err) {
      this.onClear();
      return ErrorHelpers.handleError(err);
    }

    this.onClear(); // clear values and close modal, etc.
  };

  onSubmit = () => {
    // if we're loading, we're already submitting... exit onSubmit instead of letting user double submit the by double tapping the button
    if (this.state.loading) {
      return;
    }

    // start the loader
    this.setState({ loading: true });

    let params = this.getParams();

    if (!params.title) {
      this.setState({ loading: false });
      return message.success('Please provide a question!');
    }

    if (!params.categories || !params.categories.length || params.categories.length === 0) {
      this.setState({ loading: false });
      return message.success('Please choose at least one category!');
    }

    let variables = { params };

    // TODO: do some validation

    this.onSuccessfullyValidated(variables);
  };

  onToggleModal = () => {
    this.onClear()
    this.setState({ visible: !this.state.visible });
  };

  onChange = changedValue => {
    this.setState(changedValue);
  };

  render() {
    const formComponent = !this.state.loading ? (
      <QuestionForm
        onChange={this.onChange}
        title={this.state.title}
        categories={this.state.categories}
        {...this.props}
      />
    ) : (
      <div />
    );

    return (
      <React.Fragment>
        <Button style={{
              position: 'absolute',
              right: 0,
              top: -7,
              width: 175,
            }} onClick={this.onToggleModal} type="primary">
          + CUSTOM QUESTION
        </Button>
        <FormModal
          title={'Add a Custom Question'}
          visible={this.state.visible}
          onSubmit={this.onSubmit}
          onOk={this.onSubmit}
          okText={'Submit'}
          onCancel={this.onClear}
          loading={this.state.loading}
          formComponent={formComponent}
        />
      </React.Fragment>
    );
  }
}

// STYLE
// ==========================================
const s = {
  loadingContainer: {
    minHeight: 300,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  button: {
    position: 'absolute',
    right: 0,
  },
};

let options = () => {
  return {
    refetchQueries: [
      {
        query: myQuestionsQuery,
        variables: {},
      },
    ],
  };
};

// EXPORT
// ==========================================
export default graphql(createQuestion, { name: 'createQuestion', options })(CustomQuestionModal);



// WEBPACK FOOTER //
// ./src/routes/app-studio/QuestionTemplatesArea/CustomQuestionModal/index.js